import * as React from "react"
import '../scss/banner.scss'

const Banner = ({children}: {children: any}) => {
    return <div className="Banner__Container">
        {children}
    </div>
}

export default Banner